var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconUtilityWater128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_11144)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0086 86.9033C101.098 92.473 104.108 96.7159 105.039 99.6322C106.434 104.007 105.207 107.769 101.589 110.446C97.9718 113.124 94.2197 113.253 90.4277 110.446C86.6358 107.64 85.6091 103.926 86.9786 99.6322C87.8915 96.7698 90.9015 92.5269 96.0086 86.9033Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.3999 38.9025V26.1025H57.5999V38.9025",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3999 38.9025V26.1025H57.5999V38.9025",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1295 16.5029H46.8707C43.9598 16.5029 41.6001 18.652 41.6001 21.3029C41.6001 23.9539 43.9598 26.1029 46.8707 26.1029H81.1295C84.0404 26.1029 86.4001 23.9539 86.4001 21.3029C86.4001 18.652 84.0404 16.5029 81.1295 16.5029Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8146 38.4707H16V59.9807H83.9426V70.9027H108.8V46.0484C108.8 41.8634 105.236 38.4707 100.84 38.4707H84.8146Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.867 70.9033H82.1333C80.9551 70.9033 80 72.0495 80 73.4633V77.9433C80 79.3572 80.9551 80.5033 82.1333 80.5033H109.867C111.045 80.5033 112 79.3572 112 77.9433V73.4633C112 72.0495 111.045 70.9033 109.867 70.9033Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_11144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconUtilityWater128);
export default __webpack_public_path__ + "static/media/pictogramBeaconUtilityWater128.1eb2541a001241624e7ad5bb98de0a20.svg";
export { ForwardRef as ReactComponent };